(function AdzukiLoading($, Adzuki)
{
	'use strict';

	const component = {
		props: {
			loaderType: {
				type     : String,
				default  : 'div',
				validator: value => ['div', 'button'].includes(value),
			},
			icon: {
				type   : String,
				default: '<i class="fas fa-cog fa-spin"></i>'
			},
			message: {
				type   : String,
				default: '<strong>Loading</strong>'
			},
			iconOnly: {
				type   : Boolean,
				default: false
			},
			buttonClass: {
				type   : String,
				default: 'btn btn-primary'
			},
			showIcon: {
				type   : Boolean,
				 default: true
			}
		},
		template: `
			<template v-if="iconOnly">
				<span class="loading-icon adzuki-loading-icon">
					<i class="fas fa-cog fa-spin fs-4 ps-1 adzuki-loading-icon-graphic"></i>
				</span>
			</template>
			<template v-else-if="loaderType === 'button'">
				<button :class="[buttonClass, 'adzuki-loading-button']">
					<span class="adzuki-loading-button-inner">
						<i v-if="showIcon" class="fas fa-cog fa-spin fs-4 adzuki-loading-icon-graphic"></i>
						<span class="loading-message adzuki-loading-message" v-html="message"></span>
					</span>
				</button>
			</template>
			<template v-else>
				<div class="row adzuki-loading-row">
					<div class="col-12 adzuki-loading-col">
						<div class="d-flex align-items-center justify-content-start gap-2 adzuki-loading-inner">
							<span v-if="showIcon" class="loading-icon me-1 adzuki-loading-icon">
								<i class="fas fa-cog fa-spin fs-4 adzuki-loading-icon-graphic"></i>
							</span>
							<span class="loading-message adzuki-loading-message" v-html="message"></span>
						</div>
					</div>
				</div>
			</template>
		`,
	};

	Adzuki.VueComponents.AdzukiLoading = component;
}(jQuery, window.Adzuki || {}));
